module.exports = __webpack_public_path__ + "components/intersport-discount-page/promo-article/static/article-image-7a52fe99f09343347b049999ca39d878.jpg";